import React, { useEffect } from "react";
import PrivacyTemplate from "../../Templetes/Privacy/Privacy.template";

const PrivacyPage = () => {
  useEffect(() => {
    document.title = "International Robot Challenge - Privacy Policy";
  }, []);
  return <PrivacyTemplate />;
};

export default PrivacyPage;
